/**
 * Returns the targetValue if not undefined, otherwise returns default
 *
 * @param {*} targetValue - The target value that is preferred
 * @param {*} defaultValue - The backup in case preferred is undefined
 * @returns {*} - targetValue || defaultValue
 */
const getPreferredValue = (targetValue, defaultValue) => typeof targetValue !== 'undefined' ? targetValue : defaultValue;
var getPreferredValue$1 = getPreferredValue;

export { getPreferredValue$1 as default };
